import api from "../../service";
import middleware from "../../middleware";

class TemplateService extends middleware {
	constructor() {
		super();
		this.url = `${api.defaults.baseURL}/template`;
	}

	async getTemplates(data = null) {
		var response = await api.get(`${this.url}/all`, {
			params: {
				...api.params,
				...(data.hide 				? { hide: 			data.hide } : {} ),
				...(data.departmentId 		? { department_id: 	data.departmentId } : {} ),
				...(data.status 			? { status: 		data.status } : {} ),
				...(data.journal			? { journal: 		data.journal } : {} ),
				...(data.dataregistration 	? { dataregistration: 		data.dataregistration } : {} ),
			},
		});
		return response;
	}
	async getOwnedTemplates(data = null) {
		var response = await api.get(`${this.url}/owned`, {
			params: {
				...api.params,
				...(data.hide 				? { hide: 			data.hide } : {} ),
				...(data.departmentId !== undefined && data.departmentId !== null ? { department_id: data.departmentId } : {} ),
				...(data.status 			? { status: 		data.status } : {} ),
				...(data.journal			? { journal: 		data.journal } : {} ),
				...(data.dataregistration 	? { dataregistration: 		data.dataregistration } : {} ),
			},
		});
		return response;
	}

	async getTemplate(id) {
		const { data } = await api.get(`${this.url}/get`, {
			params: {
				...api.params,
				template_id: id
			},
		});
		let end = new Date();
		return data;
	}
	
	async create(data) {
		const { response } = await api.post(`${this.url}/store`, data);
		return response;
	}

	async submit(data) {
		const { response } = await api.post(`${this.url}/fill`, data);
		return response;
	}

	async getTemplateHistory(data = null) {
		let response = await api.get(`${this.url}/history`, {
			params: {
				...api.params,
				...(data.template_id 	? { template_id: 	data.template_id } : {} ),
				...(data.date 			? { date: 			data.date } : {} ),
				...(data.order 			? { order: 			data.order } : {} ),
			},
		});
		return response;
	}

	async getDaysWithAnswers(id) {
		let response = await api.get(`${this.url}/daysWithAnswers/${id}`);
		return response;
	}

	async getTemplateDepartments(hqId) {
		let response = await api.get(`${this.url}/departments/${hqId}`);
		
		return response;
	}

	async exportTemplate(data = null) {
		let response = await api.get(`${this.url}/templateExport`,{
			responseType: 'blob',
			params: {
				...api.params,
				template_id: data.template_id,
				start_date: data.start_date,
				end_date: data.end_date,
				...(data.student_id	? {student_id: data.student_id} : {})
			},
			
		});
		return response;
	}

	async deleteAnswers(templateId, date, order) {
		let response = await api.delete(`${this.url}/deleteAnswers`,{
			responseType: 'blob',
			params: {
				...api.params,
				template_id: templateId,
				date: date,
				order: order,
			},
			
		});
		return response;
	}
	
	async getJournalTemplateHistory(templateId) {
		let response = await api.get(`${this.url}/journalTemplateHistory`, {
			params: {
				...api.params,
				template_id: templateId,
			},
			
		});
		return response;
	}
	
	async templateByDepId(dep_id) {
		const { data } = await api.get(`${this.url}/department/${dep_id}`)
		return data
	}
}

export default TemplateService;
